import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Cookie from 'utils/cookies';
import ElementInView from 'components_v2/common/ElementInView/ElementInView';
import { gaWrapper } from '../../helpers/analytics';
import s from './TimesClubWebRHS.scss';
import { TIMES_CLUB_RHS_CTA } from '../../constants';

function TimesClubWebRHS(props) {
  const [show, setShow] = useState(false);
  const { isPrime } = props;

  const handleCTAClick = () => {
    gaWrapper('send', 'event', 'TOI_US_TC', `click_tcrhs`);
  };

  useEffect(() => {
    if (Cookie.get('geo_country') === 'US') {
      setShow(true);
    }
  }, []);

  return (
    show && (
      <ElementInView gaCategory="TOI_US_TC" gaAction="view_tcrhs">
        <div className={s.band_wrapper}>
          <div className={`${s.tc_band_rhs} ${isPrime ? s.tc_prime : ''} `}>
            <div className={s.logo}>
              <img
                src="https://static.toiimg.com/photo/83917090.cms"
                alt="logo"
              />
            </div>
            <div className={s.tc_head}>
              Sign up now to earn cash back every day and unlock free rewards!
            </div>
            <div className={s.desc}>
              #1 Cashback and Rewards program for Indians in the U.S.
            </div>
            <a
              href={TIMES_CLUB_RHS_CTA}
              className={s.tc_cta}
              onClick={handleCTAClick}
              target="_blank"
              rel="nofollow noopener noreferrer"
            >
              Start Earning Now!
            </a>
          </div>
        </div>
      </ElementInView>
    )
  );
}

const mapStateToProps = state => ({
  isPrime: state.isPrime,
});

TimesClubWebRHS.propTypes = {
  isPrime: PropTypes.bool,
};
TimesClubWebRHS.defaultProps = {
  isPrime: false,
};

export default connect(mapStateToProps)(TimesClubWebRHS);
